import { render, staticRenderFns } from "./SecondQualityDonutChartReport.vue?vue&type=template&id=f1496398&scoped=true&"
import script from "./SecondQualityDonutChartReport.vue?vue&type=script&lang=js&"
export * from "./SecondQualityDonutChartReport.vue?vue&type=script&lang=js&"
import style0 from "./SecondQualityDonutChartReport.vue?vue&type=style&index=0&id=f1496398&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1496398",
  null
  
)

export default component.exports